<template>
  <div id="send_mail">
    <dd-header
      :headerType=1
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>新規登録</h2>
        </div>
        <p>フォームよりメールアドレスを入力して仮登録を行ってください。<br>
        仮登録したメール宛に本会員登録手続きのご案内メールを自動送信いたします。<br>ご案内メールに記載されたURLより本登録を行ってください。</p>
        <div>
          <ul>
            <li>
              <label class="item_title text_left">メールアドレス</label>
            </li>
            <li class="mail_form">
              <input type="text" v-model.trim="mailAddress" placeholder="メールアドレスを入力してください。"/>
              <button type="submit" class="main_btn" @click="sendMail()">仮登録する</button>
            </li>
            <li class="small_text">メールアドレスには、半角英字、数字、ピリオド、ハイフンが使用できます。</li>
          </ul>
          <label v-if="errors.email" class="error_text">{{errors.email}}</label>
          <div class="error_text">{{ errorMessage.text }}</div>
        </div>
        <ul class="for_mail">
          <li>※受信制限をされている方は、「<label class="weighty">@domans.co.jp</label>」からのメールを受信許可に設定してください</li>
          <li>※メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。</li>
        </ul>
        <div id="regist_btn">
          <a>
            <button class="main_btn cancel_btn" @click="toLogin()">戻る</button>
          </a>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as Check from '../../utils/Check'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'

// Module
import Header from '../components/common/DcHeader'

export default {
  components: {
    'dd-header': Header,
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      mailAddress: '',
      paramForm: {},
      errors: {},
      submitDisable: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' }
    }
  },
  methods: {
    toLogin: function () {
      this.$router.push('/mmstyle/login')
    },
    sendMail: function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)

      this.errors = {}
      this.validatedReqire()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }
      App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)

      let payload = {
        mailAddress: this.mailAddress,
        inviteCode: this.paramForm.code,
        payment: this.paramForm.payment
      }
      axios.post(DC_URL.USER + '/new/user', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
            App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)
            this.$router.push('/mmstyle/user/mail-comp')
          }
        }).catch(error => {
          this.errorMessage.text = error.response.data.errorMessage
        })
        .finally(() => {
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
        })
    },
    validatedReqire: function () {
      if (!Check.isMail(this.mailAddress)) {
        this.errors['email'] = 'メールアドレスが正しくありません'
      }
    }
  },
  created: function () {
    if (this.$route.query.code) {
      this.paramForm = {
        code: this.$route.query.code,
        payment: this.$route.query.payment
      }
      App.setLocalStorage(DC_STORAGE_KEY.INVITE_CODE, this.paramForm)
    } else {
      let lparam = App.getLocalStorage(DC_STORAGE_KEY.INVITE_CODE)
      if (lparam && Object.keys(lparam).length > 0) {
        this.paramForm = lparam
      }
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/SendMail.vue